import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { BaseSiteService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subject, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CustomProdPgService } from 'src/app/custom-prod-pg/custom-prod-pg.service';
import { LocationStripService } from 'src/app/shared/modules/location-strip/location-strip.service';
import { CustomAddToCartService } from '../../custom-add-to-cart/custom-add-to-cart.service';
import { CustomProductAddress } from '../../shared/model/addresses.model';
import { AllCartsApi } from '../../shared/model/cart.model';
import { PriceChannel } from '../../shared/model/price-channel.model';
import { SharedService } from '../../shared/services/shared.service';

@Component({
  selector: 'app-custom-header-change-account',
  templateUrl: './custom-header-change-account.component.html',
  styles: [
    '.header-modal .modal-dialog { overflow: hidden; }',
    '.header-modal .modal-dialog .modal-content { flex-shrink: 0; }',
    '.header-modal .modal-dialog .modal-content.step-1.move-left{ display: none }',
    '.back-btn { position: absolute; left: 10px; top: 0; z-index: 100; }',
  ],
})
export class CustomHeaderChangeAccountComponent implements OnInit, OnDestroy {
  usergetDataObj: any;
  userAccountId: string;
  userAccountgetData: any;
  showLocStrip = false;
  showChangeOption: boolean;
  baseSiteId: string;
  selectedSoldToData: any;
  soldToLocations: CustomProductAddress[];
  soldToSearchedLocations: Array<any>;
  stepTwo: boolean = false;
  private destroySubject = new Subject<void>();
  shipToMultiple: boolean = false;
  shipToLocations: CustomProductAddress[];
  shipToSearchedLocations: CustomProductAddress[];
  selectedShipToData: any;
  cartItems: any;
  cartId: any;
  noShipLoc: boolean = false;
  @ViewChild('content') modalContent;
  showChangeShip: boolean = false;
  stepThree: boolean = false;
  selectedChannel: string = '';
  selectedAccount: any;
  openFromChannel: boolean = false;
  customerGroupType: string = '';
  header: string;
  userSubscriber: Subscription;
  userAccountAddressSubscriber: Subscription;
  cartItemsSub: Subscription;
  subGetShipAddress: Subscription;
  subEmulate: Subscription;

  constructor(
    private readonly locService: LocationStripService,
    private readonly user: UserAccountFacade,
    private readonly ref: ChangeDetectorRef,
    private readonly baseSiteService: BaseSiteService,
    protected readonly modal: NgbModal,
    private readonly sharedService: SharedService,
    private readonly addToCart: CustomAddToCartService,
    private readonly plpService: CustomProdPgService,
    private readonly addToCartService: CustomAddToCartService,
    protected csAgentAuthService: CsAgentAuthService
  ) {}

  ngOnInit(): void {
    this.userSubscriber = this.user.get().subscribe((res) => {
      if (!res) {
        this.showLocStrip = false;
        this.ref.detectChanges();

        return;
      }

      this.userAccountgetData = res;
      this.showLocStrip = true;
      this.sharedService.setSessionStorage(
        'userAccountId',
        this.userAccountgetData?.orgUnit?.uid
      );
      this.userAccountId = this.userAccountgetData?.orgUnit?.uid;
      this.checkCart(res?.uid);

      if (this.userAccountgetData.channel) {
        sessionStorage.setItem(
          'selectedChannel',
          this.userAccountgetData.channel
        );
      } else if (!sessionStorage.getItem('selectedChannel')) {
        if (this.userAccountgetData.customerGroupType === 'PHARMACIST') {
          sessionStorage.setItem('selectedChannel', 'PRIVATE');
        } else if (this.userAccountgetData.customerGroupType === 'GOVERNMENT') {
          sessionStorage.setItem('selectedChannel', 'PUBLIC');
        } else {
          sessionStorage.setItem('selectedChannel', 'PRIVATE'); // Default fallback
        }
      }

      this.ref.detectChanges();
    });

    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));

    this.subEmulate = this.csAgentAuthService
      .isCustomerEmulated()
      .subscribe((emStatus) => {
        if (!emStatus) {
          this.customerGroupType = '';
        }
      });
  }

  checkCart(uid: string): void {
    // Check Cart
    this.plpService.getCarts(uid);
    this.cartItemsSub = this.plpService.cartItems$
      .pipe(take(2))
      .subscribe((res: AllCartsApi) => {
        if (
          res &&
          res?.carts[0] &&
          res?.carts[0]?.childCarts[0]?.contractId &&
          sessionStorage.getItem('selectedChannel') === PriceChannel.PRIVATE
        ) {
          this.addToCartService.clearCartNoReload(
            res?.carts[0]?.childCarts[0]?.code
          );
        }
      });
  }

  getShipTo(sapCustomerID: string, loc: string): void {
    if (this.userAccountgetData?.userName) {
      this.locService.getShipToToAddress(
        this.userAccountgetData?.userName,
        sapCustomerID
      );
      this.locService.$shipToAddress.pipe(take(1)).subscribe((res) => {
        this.shipToLocations = [...res.res.shippingAddresses].sort((a, b) =>
          a.sapCustomerID < b.sapCustomerID ? -1 : 1
        );

        this.shipToSearchedLocations = this.shipToLocations;
        this.selectedAccount = res;

        if (this.shipToSearchedLocations.length > 1) {
          this.shipToMultiple = true;

          if (
            loc === 'first-load' &&
            !this.sharedService.getSessionStorage('isShowFlag')
          ) {
            this.openModal(this.modalContent, '');

            if (this.soldToLocations?.length === 1) {
              this.stepTwo = true;
            }
          }
        } else {
          if (
            !this.sharedService.getSessionStorage('isShowFlag') &&
            this.customerGroupType === 'WHOLESALER'
          ) {
            this.sharedService.setSessionStorage('isShowFlag', true);
            this.openModal(this.modalContent, 'channel');
          }

          this.shipToMultiple = false;
        }

        if (res?.res?.customerGroupType) {
          this.customerGroupType = res?.res?.customerGroupType;
        }
        this.header = 'account';
        this.ref.detectChanges();
      });
      this.ref.detectChanges();
    }
  }

  selectChannel(data: PriceChannel): void {
    this.selectedChannel = data;
  }

  modalStepTwo(): void {
    this.stepTwo = true;
  }

  openModal(content: TemplateRef<any>, source: string): void {
    this.modal.open(content, {
      centered: true,
      backdrop: 'static',
      windowClass: `locStripModal ${this.baseSiteId}`,
    });
    this.sharedService.setSessionStorage('isShowFlag', true);
    if (source === 'channel') {
      this.stepThree = true;
      this.openFromChannel = true;
    } else {
      this.stepThree = false;
      this.openFromChannel = false;
    }
    this.header = source;
  }

  selChannelSource(e: string): void {
    if (e === 'account') {
      this.changeAccount();
    }
  }

  searchClientName(data: any): void {
    if (data.length > 0) {
      const fieldsToCheck = [
        'companyName',
        'unitID',
        'line1',
        'line2',
        'town',
        'postalCode',
        'cnpjNumber',
      ];
      this.soldToLocations = this.soldToSearchedLocations.filter((x) =>
        fieldsToCheck.some((field) =>
          x[field]?.toLowerCase().includes(data.toLowerCase())
        )
      );
    } else {
      this.soldToLocations = this.soldToSearchedLocations;
    }
  }

  searchShipTo(data: string): void {
    if (!data) {
      this.shipToLocations = this.shipToSearchedLocations;
    }

    const lowerCaseData = data.toLowerCase().trim();
    const fieldsToSearch = [
      'companyName',
      'unitID',
      'cnpjNumber',
      'line1',
      'line2',
      'town',
      'postalCode',
    ];

    this.shipToLocations = this.shipToSearchedLocations.filter(
      (x) =>
        fieldsToSearch.some((field) =>
          x[field]?.toLowerCase().includes(lowerCaseData)
        ) || x.region?.isocodeShort?.toLowerCase().includes(lowerCaseData)
    );
  }

  onOptionsSelected(address: CustomProductAddress): void {
    this.selectedSoldToData = address;
    this.getShipTo(address.sapCustomerID, 'option-selected');
    this.ref.detectChanges();
  }

  onShipToSelected(address: CustomProductAddress): void {
    this.selectedShipToData = address;
  }

  changeAccount(): void {
    let asmUserId = localStorage.getItem('asmUserId');

    if (!this.sharedService.getLocalStorage('asmEnabled') && !asmUserId) {
      asmUserId = 'current';
    }

    const unitId = this.selectedSoldToData?.unitID
      ? this.selectedSoldToData?.unitID
      : this.userAccountgetData.orgUnit.uid;
    this.locService.saveSelectedAccount(asmUserId, unitId);
    const shipTo = this.selectedShipToData?.unitID
      ? this.selectedShipToData?.unitID
      : this.shipToLocations[0]?.sapCustomerID;

    this.locService.saveSelectedShipToAddress(asmUserId, shipTo);
    this.updateShipToAddressForCart(shipTo);
    this.getShipTo(shipTo, 'change-account');
    this.ref.detectChanges();
    this.modal.dismissAll();
    this.stepTwo = false;
    this.stepThree = false;
  }

  updateShipToAddressForCart(unitID: string): void {
    this.addToCart.allCartItems$
      .subscribe((res: AllCartsApi) => {
        if (!res) {
          return;
        }

        this.cartItems = res?.carts.filter((item) => !item.saveTime);
        this.cartItems = this.cartItems[this.cartItems?.length - 1];
        this.cartId = this.cartItems?.code;

        if (!this.cartId) {
          return;
        }

        this.addToCart.saveLocation(
          unitID,
          this.cartId,
          this.userAccountgetData?.userName
        );
      })
      .unsubscribe();
  }

  ngOnDestroy(): void {
    this.userSubscriber?.unsubscribe();
    this.userAccountAddressSubscriber?.unsubscribe();
    this.destroySubject?.next();
    this.destroySubject?.unsubscribe();
    this.subGetShipAddress?.unsubscribe();
    sessionStorage.removeItem('isShowFlag');
    sessionStorage.removeItem('selectedChannel');
    sessionStorage.removeItem('userAccountId');
    this.selectedSoldToData = null;
    this.userAccountgetData = null;
    this.subEmulate?.unsubscribe();
  }
}
